import { VideoFile } from 'common/pages/EditorPage/models/types';
import { getBase64FromFile } from 'common/services/files.service';

export const getVideoFile = async (file: File): Promise<VideoFile> => ({
  base64: await getBase64FromFile(file),
  file
});
